import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addToast } from 'src/old/actions';
import { type FlexflowEmployeeDataToDisplay } from '../../Contracts/types';
import { ActionButtonLabels, ActionButtonValues } from '../../types';
import { type Employee } from 'src/shared/types/employee';
import { useUpdateFlexflowEmployeesBulkMutation } from 'src/shared/api/flexflow';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import i18n from 'src/i18n';
import { showBulkActionConfirmationModal } from '../../Contracts/FlexflowContractListActions/utils';

export const useUpdateFlexflowContractModal = (data: FlexflowEmployeeDataToDisplay | Employee) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const [updateFlexflowEmployeesBulk] = useUpdateFlexflowEmployeesBulkMutation();

  const updateInvitationStatus = async (invitationStatus: ActionButtonValues) => {
    if (!data) {
      return;
    }

    await updateFlexflowEmployeesBulk({
      employeeIds: [Number(data.id)],
      data: {
        invitationStatus
      }
    });

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: i18n.t('flexflow.updated successfully The changes will be reflected in a few minutes', {
          ns: 'actions'
        })
      })
    );
  };

  const disableButtonLabel = t(ActionButtonLabels.DISABLE, {
    ns: 'flexflow'
  });

  const inviteButtonLabel = t(ActionButtonLabels.INVITE, {
    ns: 'flexflow'
  });

  const openConfirmationModal = (actionType: ActionButtonValues) => {
    showBulkActionConfirmationModal({
      dispatch,
      t,
      selectedContracts: 1,
      actionType,
      onConfirm: updateInvitationStatus
    });
  };

  const handleDisableClick = () => {
    openConfirmationModal(ActionButtonValues.NOT_INVITED);
  };

  const handleInviteClick = () => {
    openConfirmationModal(ActionButtonValues.INVITE);
  };

  return {
    handleDisableClick,
    handleInviteClick,
    disableButtonLabel,
    inviteButtonLabel
  };
};
